import { ActHttpService } from './act-http/act-http.service';
import { AffiliateService } from './affiliate/affiliate.service';
import { AppConfigService } from './app-config/app-config.service';
import { ApprovalService } from 'app/services/approval/approval.service';
import { AuthenticationGuard } from './guard/authentication.guard';
import { AuthenticationService } from './authentication/authentication.service';
import { AuthorizationGuard } from './guard/authorization.guard';
import { BannerService } from './banner/banner.service';
import { BookingService } from './booking/booking.service';
import { CartService } from './cart/cart.service';
import { CheckoutService } from './checkout/checkout.service';
import { CommonModule } from '@angular/common';
import { ExtraGuard } from './guard/extra.guard';
import { NgModule } from '@angular/core';
import { ProductService } from './products/product.service';
import { RatingService } from './rating/rating.service';
import { SearchService } from './search/search.service';
import { UserFeatureService } from './user-feature/user-feature.service';
import { UserService } from './user/user.service';
import { UtilitiesService } from './utilities/utilities.service';
import { WarningService } from './warning/warning.service';
import { SupplierConfirmationService } from './confirmationSupplier/supplier-confirmation.service';
import { PromotionService } from './promotion/promotion.service';
import { MiceService } from './mice/mice.service';
import { GuestInfoService } from './checkout/guest-info.service';
import { ThankyouService } from './thankyou/thankyou.service';
import { BudgetService } from './budget/budget.service';
import { AuthorizeService } from './authorize/authorize.service';
import { FleetService } from './fleet/fleet.service';
import { NoticeService } from 'app/services/notice/notice.service';
import { GoogleTagManagerService } from './analytics/google-tag-manager.service';
import { CurrencyService } from './currency/currency.service';
import { PinService } from './pin/pin.service';
import { EncryptService } from './encrypt/encrypt.service';
import { LanguageCurrencyGuard } from './guard/language-currency.guard';
import { PageGuard } from './guard/page.guard';
import { AppDeepLinkGuard } from './guard/app-deep-link.guard';
import { PromotionCodeService } from './promotion-code/promotion-code.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: [
    UserService,
    UtilitiesService,
    AppConfigService,
    AuthenticationGuard,
    AuthorizationGuard,
    ExtraGuard,
    LanguageCurrencyGuard,
    ActHttpService,
    SearchService,
    BookingService,
    AuthenticationService,
    ProductService,
    CartService,
    CheckoutService,
    AffiliateService,
    WarningService,
    UserFeatureService,
    ApprovalService,
    RatingService,
    BannerService,
    SupplierConfirmationService,
    PromotionService,
    MiceService,
    GuestInfoService,
    ThankyouService,
    BudgetService,
    AuthorizeService,
    FleetService,
    NoticeService,
    GoogleTagManagerService,
    CurrencyService,
    PinService,
    EncryptService,
    PageGuard,
    AppDeepLinkGuard,
    PromotionCodeService,
  ]
})
export class ServicesModule { }



// WEBPACK FOOTER //
// ./src/app/services/services.module.ts